const wowApp = require('angular').module('oly.common');

wowApp.directive('olyErrorSrc', [require('./error-src.directive')]);



// WEBPACK FOOTER //
// ./src/olycommon/error-src/index.js